module.exports = __webpack_public_path__ + "static/media/result-test-failure.a2ec1d2c.svg";